<template>
    <div>
        <div class="form-group">
            <label style="font-size: .9em;">{{ label }}</label>
            <multiselect
                :disabled="disabled"
                :options="options"
                :multiple="true"
                :value="internalObjectValue"
                label="label"
                track-by="value"
                @input="changed"
            ></multiselect>
        </div>
    </div>
</template>

<style>
    .form-group .multiselect { width: 100%; z-index: 0;  }
    .form-group .multiselect.multiselect--active { z-index: 49;  }
</style>

<script>
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        components: { Multiselect },
        props: {
            label: {
                type: String,
                default: ''
            },
            value: {
                type: [Array, String, Number],
                default() {
                    return []
                }
            },
            filterOptions: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            config: {
                type: Object,
                default() {
                    return {
                        type: false
                    };
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        created() {
            this.internalValue = this.value
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    this.internalValue = n
                } 
            }
        },
        computed: {
            options() {
                let options = this.filterOptions;

                if (typeof this.filterOptions === 'object' && !Array.isArray(this.filterOptions)) {
                    options = []

                    for (let i in this.filterOptions) {
                        options.push({ value: i, label: this.filterOptions[i] })
                    }
                }

                return options ? options : []
            },
            internalObjectValue() {
                if (typeof this.internalValue === 'object' && this.options.length > 0) {
                    return this.internalValue.map(item => {
                        return this.options.find(i => {
                            return String(i.value) === String(item)
                        })
                    })
                } else if(this.options.length > 0) {
                    return this.options.find(i => {
                        return String(i.value) === String(this.internalValue)
                    })
                }

                return []
            }
        },
        data() {
            return {
                internalValue: []
            }
        },
        methods: {
            changed(e) {
                if (e && e.length > 0) {
                    this.internalValue = e.map(item => item.value)
                    this.$emit('input', this.internalValue)
                } else {
                    this.$emit('input', '%')
                }
            }
        }
    }
</script>